"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "style", "min", "max", "step", "value", "setValue", "data", "disabled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputRangeSlider {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* \n  \tA dummy thumb icon that rests on top of the actual one.\n  \tThis allows us to change the design of the thumb icon without having to rely heavily\n  \ton the largely unsupported ::-webkit-slider-thumb and ::-moz-range-thumb.\n  */\n}\n.InputRangeSlider__slider, .InputRangeSlider__slider--disabled, .InputRangeSlider__slider--active {\n  width: 100%;\n  appearance: none;\n  background-color: #bebebe;\n  background-repeat: no-repeat;\n  background-image: linear-gradient(#116cd0, #116cd0);\n  border-radius: 3rem;\n  height: 0.5rem;\n  cursor: pointer;\n  /*\n  \tSince `pointer-events: none` disables the `:hover` pseudo-selector, in order to\n  \tchange the background color of the thumb on hover, it must be activated here using \n  \tthe adjacent sibling combinator.\n  */\n}\n.InputRangeSlider__slider--active:hover + .InputRangeSlider__thumb, .InputRangeSlider__slider--active:hover + .InputRangeSlider__thumb--disabled {\n  background-color: #0a5ec0;\n}\n.InputRangeSlider__slider--active:active + .InputRangeSlider__thumb, .InputRangeSlider__slider--active:active + .InputRangeSlider__thumb--disabled {\n  background-color: #0a5ec0;\n}\n.InputRangeSlider__slider--disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.InputRangeSlider__slider::-webkit-slider-thumb, .InputRangeSlider__slider--active::-webkit-slider-thumb, .InputRangeSlider__slider--disabled::-webkit-slider-thumb {\n  opacity: 0;\n}\n.InputRangeSlider__thumb, .InputRangeSlider__thumb--disabled {\n  position: absolute;\n  height: 1rem;\n  width: 1rem;\n  border-radius: 3rem;\n  background-color: #116cd0;\n  border: none;\n  cursor: pointer;\n  pointer-events: none;\n}\n.InputRangeSlider__thumb--disabled {\n  background-color: #7eb3f1;\n}\n.InputRangeSlider__labelContainer, .InputRangeSlider__labelContainer--disabled {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  list-style: none;\n  text-align: center;\n  margin: 1rem 0 0 0;\n}\n.InputRangeSlider__labelContainer--disabled {\n  opacity: 0.5;\n}\n.InputRangeSlider__label--active {\n  color: #0a5ec0;\n}";
  var fileName = "InputRangeSlider_InputRangeSlider";
  var element = document.querySelector("style[data-sass-component='InputRangeSlider_InputRangeSlider']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
/**
 * An input that selects values based on different ranges. It provides a thumb icon that the user can drag to select their desired value.
 */
var InputRangeSlider = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    style = _ref.style,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 10 : _ref$max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    setValue = _ref.setValue,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  // When the user passes a data array, override the max and min ranges to fit the array.
  var MAX_RANGE = data.length ? data.length - 1 : max;
  var MIN_RANGE = data.length ? 0 : min;
  var _useState = (0, _react.useState)(value % step !== 0 ? 0 : value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1]; // Stores the numerical value of the slider as the user moves it.
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    leftLength = _useState4[0],
    setLeftLength = _useState4[1];
  var prevStepNum = (0, _react.useRef)(step);

  // When the component mounts, set the user's value so it can be used on their end immediately.
  (0, _react.useEffect)(function () {
    if (data.length) {
      setValue(data[index].value);
    } else {
      setValue(index);
    }
  }, []);

  // If the step prop ever changes, set the value and index to zero so the thumb isn't jumping around.
  (0, _react.useEffect)(function () {
    if (prevStepNum.current !== step) {
      prevStepNum.current = step;
      if (data.length) {
        setIndex(0);
        setValue(data[0].value);
      } else {
        setIndex(0);
        setValue(0);
      }
    }
  }, [step]);

  // Updates the left track's color so it follows where the thumb is positioned.
  (0, _react.useEffect)(function () {
    setLeftLength((index - MIN_RANGE) * 100 / (MAX_RANGE - MIN_RANGE));
  }, [index, min, max]);

  /**
   * Updates the value and index of the range slider whenever the user drags on the thumb button.
   * @param e onChange event handler that allows us to access the current value of the range slider.
   */
  var handleValue = function handleValue(e) {
    var sliderValue = parseInt(e.target.value);
    if (sliderValue % step === 0) {
      if (data.length) {
        setIndex(sliderValue);
        setValue(data[sliderValue].value);
      } else {
        setIndex(sliderValue);
        setValue(sliderValue);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "InputRangeSlider",
    style: _objectSpread({}, style),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      className: "InputRangeSlider__slider".concat(disabled ? '--disabled' : '--active', " ").concat(className),
      style: {
        // Allows the left side to be a different color than the right side.
        backgroundSize: "".concat(leftLength, "% 100%")
      },
      type: "range",
      min: "".concat(MIN_RANGE),
      max: "".concat(MAX_RANGE),
      step: step > MAX_RANGE ? MAX_RANGE : step,
      value: index,
      onChange: handleValue,
      disabled: disabled
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "InputRangeSlider__thumb".concat(disabled ? '--disabled' : ''),
      style: {
        left: "calc((".concat((index - MIN_RANGE) / (MAX_RANGE - MIN_RANGE), ") * ((100% - 0.5rem) - 0.5rem))"),
        bottom: data.length ? 'calc(50% + 1rem)' : '50%'
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "InputRangeSlider__labelContainer".concat(disabled ? '--disabled' : ''),
      children: data == null ? void 0 : data.map(function (element, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: "InputRangeSlider__label".concat(i === index ? '--active' : ''),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            children: element.label
          })
        }, "label-".concat(i));
      })
    })]
  });
});
var _default = InputRangeSlider;
exports["default"] = _default;